import { combineReducers }  from 'redux-immutablejs';
import runtime              from '../../../app/infrastructure/reducers/runtime';
import provider             from '../../../app/infrastructure/reducers/provider';

export default combineReducers({
    runtime,
    provider
});